import React, { useState } from "react";
import { Link } from "react-router-dom";
import CreatorAcademyTerms from "./CreatorProTerms";
import jennyImage from "../assets/jenny.jpg";
import peterImage from "../assets/peter.jpg";
import mattieImage from "../assets/mattie.jpg";
import bradfordImage from "../assets/bradford.jpg";
import majkinImage from "../assets/majkin.jpg";

export default function CreatorAcademyInfo() {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const openTermsModal = () => setShowTermsModal(true);
  const closeTermsModal = () => setShowTermsModal(false);

  // Testimonials data
  const testimonials = [
    {
      quote: "Creating your dreams doesn't have to feel so isolating and insurmountable.",
      author: "Mattie Jo Cowsert",
      title: "Author of God, Sex, and Rich People"
    },
    {
      quote: "It was almost like a slap in the face or a kick in the butt. This is what you should be doing. I was quite amazed.",
      author: "Bradford Tilden",
      title: "Composer and Best-Selling Author"
    },
    {
      quote: "I genuinely do learn something new every week that I'm like, ooh, that's what that is.",
      author: "Majkin Holmquist",
      title: "Playwright and Producer of Stargazers"
    }
  ];

  return (
    <div className="min-h-screen bg-white font-body text-black">
      {/* ---------------------------------------------------------------- */}
      {/* SECTION 1 –– Hero, Carousel + Details                            */}
      {/* ---------------------------------------------------------------- */}
      <section className="bg-white pt-12">
        <div className="mx-auto px-4 sm:px-6 md:px-24 xl:px-56 lg:grid lg:grid-cols-9 lg:gap-24">
          {/* LEFT: Hero + Details (span 2 columns on large) */}
          <div className="lg:col-span-5">
            <h1 className="mb-4 text-center font-heading text-2xl sm:text-3xl lg:text-left">
              Creator Academy – Cohort 1
            </h1>
            <h1 className="mb-8 text-gray-400 text-center font-heading text-2xl sm:text-3xl lg:text-left">
              July - October, 2025
            </h1>
            <p className="mb-6 leading-relaxed text-lg">
              A 12‑15 week intensive on how to turn your creative IP into a sustainable business. Led by
              <span className=""> Jenny Larios Berlin</span> (MIT Sloan Lecturer & Entrepreneur in Residence), this program will teach students the must‑know's of creative business and entrepreneurship.
            </p>

            {/* Details List */}
            <div className="my-8 space-y-2 text-lg">
              <h3 className="mb-4 font-heading text-lg font-semibold text-black">You'll get:</h3>
              <ul className="list-disc space-y-2 pl-5">
                <li>
                  <span className="">12-15 × 3‑hour</span> live Zoom workshops – recordings available after sessions
                </li>
                <li>
                  Weekly <span className="">action‑oriented homework</span> with AI feedback & concrete deliverables
                </li>
                <li>
                  Supplemental materials through the Makerstate digital platform
                </li>
                <li>
                  <span className="">Weekly 45‑min discussion sections</span> hosted by Peter Li (Yale C.S. & Theater)
                </li>
                <li>
                  Lifetime access to network of peers, recordings, & future updates
                </li>
                <li>
                  <span className="">Priority support</span> throughout the program
                </li>
                <li>
                  <span className="font-medium">Regular tuition: $499</span>
                </li>
                <li>
                  <span className="font-medium">Early‑bird tuition: $299 - <a href="mailto:peter@makerstate.com?subject=Creator%20Academy%20Discount%20Code%20Request&body=Hi!%20I'd%20like%20to%20request%20a%20discount%20code%20for%20the%20Creator%20Academy.%0D%0A%0D%0AThanks!" className="text-blue-600 hover:underline">email us for discount code</a></span>
                </li>
              </ul>
            </div>
          </div>

          {/* RIGHT: Instructor Profiles */}
          <aside className="mt-12 lg:mt-0 lg:col-span-4">
            <div className="rounded-2xl border border-gray-200 p-6">
              <h3 className="mb-6 text-xl font-medium font-heading">Meet Your Guides</h3>

              {/* Jenny */}
              <div className="flex gap-4">
                <img
                  src={jennyImage}
                  alt="Portrait of Jenny Larios Berlin"
                  className="h-24 w-24 rounded-full object-cover"
                />
                <div>
                  <h4 className="text-lg font-medium">Instructor / Jenny Larios Berlin</h4>
                  <p className="text-sm leading-snug text-gray-600">
                    MIT Sloan Lecturer • Entrepreneur in Residence
                  </p>
                  <p className="text-sm leading-snug text-gray-600">
                    Co‑founder & COO, Optimus Ride (acq. by Magna)
                  </p>
                </div>
              </div>

              <p className="mt-3 text-md text-gray-700">
                Jenny has raised <span className="">$100M+</span> in venture capital, non-dilutive, and debt funding, grown teams to 200+, and scaled ventures from prototype to
                nationwide deployment. In the last few years at MIT, Jenny has taught and mentored countless entrepreneurs to successful outcomes. She will be your lead instructor throughout the course.
              </p>

              {/* Divider */}
              <div className="my-6 h-px bg-gray-200" />

              {/* Peter */}
              <div className="flex gap-4">
                <img
                  src={peterImage}
                  alt="Portrait of Peter Li"
                  className="h-24 w-24 rounded-full object-cover"
                />
                <div>
                  <h4 className="text-lg font-medium">TA / Peter Li</h4>
                  <p className="text-sm leading-snug text-gray-600">
                    Software Engineer • Yale CS & Art • Yale SOM (MMS‑TM '25) • Lead Venture Associate at Tsai CITY
                  </p>
                </div>
              </div>

              <p className="mt-3 text-md text-gray-700">
                Peter is dedicated to bridging technology and creative practice. As your teaching assistant, he'll run course logistics and weekly office hours,
                facilitate peer feedback sessions, and make sure the AI copilot is working well for every student.
              </p>
            </div>
          </aside>
        </div>
      </section>

      {/* ---------------------------------------------------------------- */}
      {/* SECTION 2 –– CTA                                                */}
      {/* ---------------------------------------------------------------- */}
      <section className="bg-white pt-10 text-center">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <p className="my-6 text-md text-black">
            By proceeding, you agree to our&nbsp;
            <button
              onClick={openTermsModal}
              className="font-medium text-black underline hover:text-gray-700 focus:outline-none"
            >
              Program Terms and Conditions
            </button>
            .
          </p>

          {/* Stripe checkout – replace with live link */}
          <a
            href="https://buy.stripe.com/14AfZjcrQb272Mb0Ns1sQ00"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-auto block w-full max-w-sm rounded-md bg-black px-8 py-4 text-lg text-white shadow-md transition hover:bg-gray-800"
          >
            Secure Early‑Bird Spot – $299
          </a>

          <p className="mt-4 text-sm text-gray-600">
            Early‑bird pricing available for the first 50 students. Tuition increases to $499 thereafter.
          </p>

          <div className="mt-8 mb-16">
            <Link to="/pricing" className="text-md text-black">
              &larr; Back to all plans
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-lg border border-gray-200 flex flex-col">
              <p className="font-body text-gray-600 italic mb-6 flex-grow">
              "Creating your dreams doesn't have to feel so isolating and insurmountable."           </p>
              <div className="flex items-center mt-auto">
                <img src={mattieImage} alt="Mattie Jo Cowsert" className="w-12 h-12 rounded-full mr-4 object-cover"/>
                <div>
                  <p className="font-semibold font-body text-gray-800">Mattie Jo Cowsert</p>
                  <p className="text-sm font-body text-gray-500">Author of <span className='italic'>God, Sex, and Rich People</span></p>
                </div>
              </div>
            </div>
            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-lg border border-gray-200 flex flex-col">
              <p className="font-body text-gray-600 italic mb-6 flex-grow">
                "It was almost like a slap in the face or a kick in the butt. This is what you should be doing. I was quite amazed.""
              </p>
              <div className="flex items-center mt-auto">
                <img src={bradfordImage} alt="Bradford Tilden" className="w-12 h-12 rounded-full mr-4 object-cover"/>
                <div>
                  <p className="font-semibold font-body text-gray-800">Bradford Tilden</p>
                  <p className="text-sm font-body text-gray-500">Composer and Best-Selling Author</p>
                </div>
              </div>
            </div>
            {/* Testimonial 3 */}
            <div className="bg-white p-8 rounded-lg border border-gray-200 flex flex-col">
              <p className="font-body text-gray-600 italic mb-6 flex-grow">
                "I genuinely do learn something new every week that I'm like, ooh, that's what that is."
              </p>
              <div className="flex items-center mt-auto">
                <img src={majkinImage} alt="Majkin Holmquist" className="w-12 h-12 rounded-full mr-4 object-cover"/>
                <div>
                  <p className="font-semibold font-body text-gray-800">Majkin Holmquist</p>
                  <p className="text-sm font-body text-gray-500">Playwright and Producer of <span className='italic'>Stargazers</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------------------------------------------- */}
      {/* Modal – Terms & Conditions                                       */}
      {/* ---------------------------------------------------------------- */}
      {showTermsModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-75 p-4">
          <div className="relative max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-lg bg-white shadow-xl">
            <div className="sticky top-0 flex items-center justify-between border-b border-gray-200 bg-white p-4">
              <h2 className="font-heading text-xl font-semibold">Creator Academy – Terms of Use</h2>
            </div>
            <div className="p-6">
              <CreatorAcademyTerms />
            </div>
            <div className="sticky bottom-0 border-t border-gray-200 bg-white p-4 text-right">
              <button
                onClick={closeTermsModal}
                className="rounded-md bg-gray-200 px-4 py-2 text-black hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Custom CSS for animation */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
